import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UsersTable } from '../../common/types/types';

interface UsersState {
  dohvaceniUsers: UsersTable[];
}

const initialState: UsersState = {
  dohvaceniUsers: [],
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setDohvaceniUsers: (state, action: PayloadAction<UsersTable[]>) => {
      return { ...state, dohvaceniUsers: action.payload };
    },
  },
});

export const { reset, setDohvaceniUsers } = usersSlice.actions;
export default usersSlice.reducer;
